<template>
  <div class="main">
    <section class="panel panel-default">
      <header class="panel-heading" style="padding: 10px;">
        <h4 class="panel-title">智慧空調管理</h4>
      </header>
      <div class="panel-body">
        <ul class="nav nav-tabs" style="margin-bottom: 12px;">
          <li :class="{ active: activeTab === 'deposit' }">
            <a href="javascript:;" @click="switchTab('deposit')">冷氣儲值/付款紀錄</a>
          </li>
          <li :class="{ active: activeTab === 'electricity' }">
            <a href="javascript:;" @click="switchTab('electricity')">電費使用紀錄</a>
          </li>
        </ul>

        <!-- 查詢條件(管理員才顯示篩選) -->
        <div class="row form-group" v-if="isAdmin">
          <div class="col-md-3">
            <label class="col-md-4">學號</label>
            <div class="col-md-8">
              <input type="text" class="form-control" v-model="query.stuId" />
            </div>
          </div>
          <div class="col-md-3">
            <label class="col-md-4">房號</label>
            <div class="col-md-8">
              <input type="text" class="form-control" v-model="query.roomNo" />
            </div>
          </div>
          <div class="col-md-3" v-if="activeTab === 'electricity'">
            <label class="col-md-4">棟別</label>
            <div class="col-md-8">
              <input type="text" class="form-control" v-model="query.building" />
            </div>
          </div>
          <div class="col-md-3 text-right">
            <button type="button" class="btn btn-primary" @click="search">查詢</button>
          </div>
        </div>
        <div class="row form-group" v-else>
          <div class="col-md-12 text-right">
            <button type="button" class="btn btn-primary" @click="search">查詢</button>
          </div>
        </div>

        <!-- 儲值/付款 -->
        <div class="table-responsive" v-if="activeTab === 'deposit'">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>序號</th><th>付款日期</th><th>房號/床號</th><th>學號/姓名</th><th>付款金額</th><th>備註</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idx) in rows" :key="idx">
                <td>{{ idx + 1 }}</td>
                <td>{{ row.payDate }}</td>
                <td>{{ row.roomNo }}{{ row.bedNo ? ' / ' + row.bedNo : '' }}</td>
                <td>{{ row.stuId }}{{ row.name ? ' / ' + row.name : '' }}</td>
                <td>{{ row.amount }}</td>
                <td>{{ row.remark }}</td>
              </tr>
              <tr v-if="rows.length === 0"><td colspan="6" class="text-center">查無資料</td></tr>
            </tbody>
          </table>
        </div>

        <!-- 電費使用 -->
        <div class="table-responsive" v-else>
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>序號</th><th>開始用電時間</th><th>結束用電時間</th><th>開始~結束度數</th>
                <th>棟別/樓層</th><th>房號/床號</th><th>學號/姓名</th><th>電費金額</th><th>餘額</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idx) in rows" :key="idx">
                <td>{{ idx + 1 }}</td>
                <td>{{ row.startTime }}</td>
                <td>{{ row.endTime }}</td>
                <td>{{ row.startDegree }} ~ {{ row.endDegree }}</td>
                <td>{{ row.building }}{{ row.floor ? ' / ' + row.floor : '' }}</td>
                <td>{{ row.roomNo }}{{ row.bedNo ? ' / ' + row.bedNo : '' }}</td>
                <td>{{ row.stuId }}{{ row.name ? ' / ' + row.name : '' }}</td>
                <td>{{ row.fee }}</td>
                <td>{{ row.balance }}</td>
              </tr>
              <tr v-if="rows.length === 0"><td colspan="9" class="text-center">查無資料</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* global bootbox */

export default {
  name: "StayAircon",
  data() {
    return {
      activeTab: "deposit",
      isAdmin: false,
      query: { stuId: "", roomNo: "", building: "", dateFrom: null, dateTo: null },
      rows: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      try {
        const resp = await this.$axios.get("/api/DormitoryAircon/init");
        if (resp.data.status === "success") {
          this.isAdmin = !!resp.data.data.isAdmin;
        }
      } catch (e) {
        // init 失敗不阻擋查詢;isAdmin 預設 false(學生視角)
      }
      this.search();
    },
    switchTab(tab) {
      if (this.activeTab === tab) return;
      this.activeTab = tab;
      this.rows = [];
      this.search();
    },
    search() {
      const url =
        this.activeTab === "deposit"
          ? "/api/DormitoryAircon/depositGrid"
          : "/api/DormitoryAircon/electricityGrid";
      const body = {
        model: {
          stuId: this.query.stuId || null,
          roomNo: this.query.roomNo || null,
          building: this.query.building || null,
          dateFrom: this.query.dateFrom || null,
          dateTo: this.query.dateTo || null
        }
      };
      const tab = this.activeTab;
      this.$axios
        .post(url, JSON.stringify(body))
        .then((resp) => {
          if (resp.data.status === "success") {
            if (this.activeTab === tab) {
              this.rows = resp.data.data.rows || [];
            }
          } else {
            this.rows = [];
            bootbox.alert(resp.data.msg || "查詢失敗");
          }
        })
        .catch(() => {
          this.rows = [];
          bootbox.alert("查詢失敗");
        });
    }
  }
};
</script>
